const routes = new Map([
  ['home', '/'],
  ['biodanza', '/servicios/biodanza'],
  ['danza-emocion', '/servicios/danza-emocion'],
  ['biodanza-perinatal', '/servicios/biodanza-perinatal'],
  ['terapia-bioenergetica', '/servicios/terapia-bioenergetica'],
  ['parto-y-movimiento', '/servicios/parto-y-movimiento'],
  ['clases-y-talleres', '/clases-y-talleres'],
  ['publicaciones', '/publicaciones'],
  ['uma', '/uma']
]);

export default routes;
